import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import {
  InspectionViewerInjection,
  inspectionViewerInjectionKey,
} from '@/teams/visionair/components/InspectionViewer/inspection-viewer.shared';
import {
  computed,
  inject,
  PropType,
  Ref,
  watch,
} from 'vue';
import { UPDATE_MODEL_EVENT } from '@/core/consts';
import { uniq } from 'lodash'

import { useGetAnnotationByLastDeviceInspectionQuery } from '@/entities/annotation/hooks';

import { Annotation } from '@/entities/annotation/types';
import { Device } from '@/entities/device/types';
import { Inspection } from '@/entities/inspection/types';

import { NkOption, NkSelect } from '@/core/components';
import { useGetAnnotationTypesQuery } from '@/entities/annotation-type/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnotationLinkSelect',
  props: {
  modelValue: {
    type: Number as PropType<Annotation['id']>,
    default: null,
  },
  annotation: {
    type: Number as PropType<Annotation['id']>,
    default: null,
  },
  inspection: {
    type: Number as PropType<Inspection['id']>,
    required: true,
  },
  device: {
    type: Number as PropType<Device['id']>,
    required: true,
  },
  highlightSelectedAnnotation: {
    type: Boolean,
    default: true,
  }
},
  emits: ['change', UPDATE_MODEL_EVENT],
  setup(__props, { expose, emit }) {

const props = __props




const injectedInspectionViewer = inject(inspectionViewerInjectionKey) as InspectionViewerInjection;

const annotationsQueryData: Ref = computed(() => ({
  device: props.device,
  inspection: props.inspection,
}));
const hasAnnotationsData = computed(() => !!(annotationsQueryData.value.device && annotationsQueryData.value?.inspection));
const {
  data: annotations,
  refetch: refetchAnnotations,
} = useGetAnnotationByLastDeviceInspectionQuery(annotationsQueryData, {
  refetchOnWindowFocus: false,
  initialData: [],
  enabled: hasAnnotationsData,
});

const selectedAnnotation = computed(() => annotations.value?.find(o => o.id === props.modelValue));

const typeIds: Ref = computed(() => uniq(annotations.value?.map(annotation => annotation.type)));
const hasTypeIds = computed(() => !!typeIds.value)
const annotationTypesQueryFilter = computed(() => ({
  ids: [...typeIds.value],
}));

const { data: annotationTypes } = useGetAnnotationTypesQuery({
  refetchOnWindowFocus: false,
  enabled: hasTypeIds,
  initialData: []
}, annotationTypesQueryFilter)

const labelAnnotation = (annotation: Annotation) => {
  const types = annotationTypes.value?.find(type => type.id === annotation.type)

  if (types){
    return `Annotation ${annotation.id} (${types.name})`
  }

  return `Annotation ${annotation.id}`
}

const handleChange = (annotation: Annotation) => {
  emit('change', annotation);
  emit(UPDATE_MODEL_EVENT, annotation);

  if (props.highlightSelectedAnnotation && injectedInspectionViewer) {
    injectedInspectionViewer.setHoveredAnnotation(annotation.id);
  }
};


watch(() => props.device, () => {
  refetchAnnotations.value();
});

expose({
  refetchAnnotations: refetchAnnotations.value,
  selectedAnnotation,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkSelect), {
    "model-value": props.modelValue,
    "onUpdate:modelValue": handleChange,
    "value-key": "id"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(annotations), (annotation) => {
        return (_openBlock(), _createBlock(_unref(NkOption), {
          key: annotation.id,
          label: labelAnnotation(annotation),
          value: annotation
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})